import { MdQueryStats } from 'react-icons/md';
import { Resources } from '../resource';
import { StatisticsPage } from './statistics-page';

export const name = Resources.boldPredictionCampaignStatistics;

export const list = StatisticsPage;

export const icon = MdQueryStats;

export const options = { label: 'module.boldPredictionCampaign.statistics.title' };
